export default "__VITE_ASSET__CWnvePYq__"